import { FC, ReactElement } from "react";
import {
  Grid,
} from "@mui/material";
import { ContactUsForm } from "@/components";
import { StyledParentWrapper } from "./styles";
// import { faqData } from "@/constants";

const HelpCenter: FC = (): ReactElement => {
  // const [expanded, setExpanded] = useState<string | false>(false);
  // const isSmallScreen = useMediaQuery("(max-width: 1200px)");

  // const handleChange =
  //   (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
  //     setExpanded(isExpanded ? panel : false);
  //   };

  return (
    <Grid container spacing={3}>
      {/* Left side: Contact Us Form */}
      <Grid item xs={12} lg={12} sm={12}>
        <StyledParentWrapper
          sx={{
            height: {
              xl: "800px",
              lg: "750px",
              xs: "auto",
            },
          }}
        >
          <ContactUsForm />
        </StyledParentWrapper>
      </Grid>

      {/* Right side: FAQ Section */}
      {/* <Grid item xs={12} lg={6} sm={12}>
        <StyledParentWrapper
          sx={{
            height: {
              xl: "800px",
              lg: "750px",
              xs: "auto",
            },
          }}
        >
          <Typography variant="h4" sx={{ mb: 2, fontWeight: "bold" }}>
            Frequently Asked Questions
          </Typography>

          <Stack
            direction={isSmallScreen ? "column" : "row"}
            spacing={2}
            sx={{ mb: 2 }}
          >
            <StyledNavButton variant="contained">All</StyledNavButton>
            <StyledNavButton variant="white-outlined">
              Getting Started
            </StyledNavButton>
            <StyledNavButton variant="white-outlined">Rating</StyledNavButton>
            <StyledNavButton variant="white-outlined">Others</StyledNavButton>
          </Stack>

          {faqData.map((item, index) => (
            <Accordion
              expanded={expanded === `panel${index}`}
              onChange={handleChange(`panel${index}`)}
              key={index}
              sx={{ mb: 2, borderRadius: "6px", border: "1px solid #E6E7E8" }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>{item.question}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{item.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </StyledParentWrapper>
      </Grid> */}
      
    </Grid>
  );
};

export default HelpCenter;
